import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";

import { ACTIVE_PLAN_CHANGED_EVENT } from "@/lib/activePlanSync";

/** Invalidate shared coaching queries whenever the current plan changes. */
export const ActivePlanSyncBridge = () => {
  const queryClient = useQueryClient();

  useEffect(() => {
    const onChanged = () => {
      queryClient.invalidateQueries({ queryKey: ["coaching-context"] });
      queryClient.invalidateQueries({ queryKey: ["coaching-explanation"] });
    };
    window.addEventListener(ACTIVE_PLAN_CHANGED_EVENT, onChanged);
    return () => window.removeEventListener(ACTIVE_PLAN_CHANGED_EVENT, onChanged);
  }, [queryClient]);

  return null;
};

export default ActivePlanSyncBridge;
